import React from "react"

import AccordionComponent from "./Accordion"

export const Accordion = props => {
  return <AccordionComponent {...props} />
}

export default Accordion
